import React from "react";
import { X } from "lucide-react";
import { Select, FormField } from "../../UI/FormField";
import Button from "../../UI/Button";

interface CompanyFiltersProps {
  filters: {
    status: string;
  };
  setShowFilters: (show: boolean) => void;
  onFiltersChange: (filters: any) => void;
  onClearFilters: () => void;
}

const CompanyFilters: React.FC<CompanyFiltersProps> = ({
  filters,
  setShowFilters,
  onFiltersChange,
  onClearFilters,
}) => {
  return (
    <div>
      <div className="flex items-center justify-between mb-4">
        <h3 className="text-sm font-medium text-gray-900">Filters</h3>
        <button
          onClick={() => setShowFilters(false)}
          className="text-gray-400 hover:text-gray-600"
        >
          <X className="h-4 w-4" />
        </button>
      </div>

      <div className="space-y-4">
        <FormField label="Status">
          <Select
            value={filters.status}
            onChange={(e) => onFiltersChange({ status: e.target.value })}
          >
            <option value="">All Status</option>
            <option value="active">Active</option>
            <option value="inactive">Inactive</option>
          </Select>
        </FormField>

        <div className="flex space-x-2 pt-2">
          <Button variant="outline" onClick={onClearFilters} className="flex-1">
            Clear
          </Button>
          <Button
            variant="primary"
            onClick={() => setShowFilters(false)}
            className="flex-1"
          >
            Apply
          </Button>
        </div>
      </div>
    </div>
  );
};

export default CompanyFilters;
